const API_ENDPOINTS = {
  // Auth endpoints
  AUTH: {
    LOGIN: "/fz-backend-api/api/v1/auth/login",
    FORGETPASSWORD: "/fz-backend-api/api/v1/password/forgot",
    CHECKFORGETCODE: "/fz-backend-api/api/v1/password/verify-forget-code",
    CHECKCODE: "/fz-backend-api/api/v1/users/validate",
    GETOTP: "/fz-backend-api/api/v1/password/send-email-code",
    CHANGEPASSWORD: "/fz-backend-api/api/v1/password/change",
    CHANGE_EMAIL: "/fz-backend-api/api/v1/password/change-email",
    REFRESH: "/fz-backend-api/api/v1/auth/refresh",
  },

  // Team endpoints
  TEAM: {
    LIST: "/fz-backend-api/api/v1/companies/list",
    BANNERS: "/fz-backend-api/api/v1/banners",
    // CREATE: '/team',
    // GET: (id) => `/team/${id}`,
    // UPDATE: (id) => `/team/${id}`,
    // DELETE: (id) => `/team/${id}`,
  },

  // Example resource endpoints
  MENU: {
    LIST: "/fz-backend-api/api/v1/users/menu",
    // CREATE: '/company',
    // GET: (id) => `/company/${id}`,
    // UPDATE: (id) => `/company/${id}`,
    // DELETE: (id) => `/company/${id}`,
  },
};
export default API_ENDPOINTS;
